<div class="main-container-left-side">
  <left-sport-menu-desktop (favPreMatchesClicked)="openFavPreMatches()"></left-sport-menu-desktop>
</div>

<div class="main-container-mid-side">
  <!-- E-Mail Verifiation -->
  <div class="verification-container" *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && !this._UserHelper.emailIsVerified">
    <div class="icon">
      <image-loader-utils url="mail" extraClasses="slidermenusvg"></image-loader-utils>
    </div>
    <div class="text">
      {{ 'b3000_email_verification_text' | t }}
      <b style="cursor: pointer" class="{{ this.resendMailButtonState ? '' : 'disable-button' }}" (click)="reSendConfirmation()">
        <u>{{ 'b3000_email_verification_text2' | t }}</u>
      </b>
    </div>
  </div>

  <!--  0 => Not Checked-->
  <!--  1 => Pre Checked-->
  <!--  2 => Checked-->

  <!-- Insic Not Checked -->
  <div
    class="verification-container"
    *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && (_UiHelper.insicStatus == 0 || _UiHelper.insicStatus == -1 || _UiHelper.insicStatus == -2)"
    (click)="showTabsMenuMobile(2)">
    <div class="icon">
      <image-loader-utils url="info-user" extraClasses="slidermenusvg"></image-loader-utils>
    </div>
    <div class="text" *ngIf="_UiHelper.insicStatus == 0 || _UiHelper.insicStatus == -1">
      {{ 'b3000_insic_status_not_checked1' | t }}
      <b>
        {{ 'b3000_insic_status_not_checked_link1' | t }} <u>{{ 'b3000_insic_status_not_checked_link_21' | t }}</u>
      </b>
    </div>
    <div class="text" *ngIf="_UiHelper.insicStatus == -2">
      {{ 'b3000_insic_status_not_checked' | t }}
      <b>
        {{ 'b3000_insic_status_not_checked_link' | t }} <u>{{ 'b3000_insic_status_not_checked_link_2' | t }}</u>
      </b>
    </div>
  </div>
  <!-- Insic Not Checked -->

  <!-- Insic Pre Checked -->
  <div class="verification-container" *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && _UiHelper.insicStatus == 1" (click)="showTabsMenuMobile(2)">
    <div class="text">
      {{ 'b3000_insic_status_pre_checked' | t }}
      <div class="mt-8">
        <b>
          {{ 'b3000_insic_status_pre_checked_link' | t }}
        </b>
      </div>
    </div>
  </div>
  <!-- Insic Pre Checked -->
  <ng-container [ngSwitch]="['wettarena', 'b500', 'cangobet', 'terminalPeru'] | getProductName">
    <ng-container *ngSwitchCase="'wettarena'">
      <div *ngIf="this._UiHelper.sliderWebData && this._UiHelper.sliderWebData.length > 0" class="slider-desktop" (click)="goToLink(this._UiHelper.sliderWebData[0]?.Link)">
        <img [style.width]="'100%'" [src]="this._UiHelper.sliderWebData[0]?.FileName" alt="" [style.object-fit]="'contain'" style="object-position: left" />
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'b500'">
      <div class="slider-desktop">
        <img [style.width]="'100%'" src="https://cdnsport.s3.eu-central-1.amazonaws.com/cms/main_banner.png" alt="" [style.object-fit]="'contain'" style="object-position: left" />
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'cangobet'">
      <div *ngIf="this._UiHelper.sliderWebData && this._UiHelper.sliderWebData.length > 0" class="slider-desktop" (click)="goToLink(this._UiHelper.sliderWebData[0]?.Link)">
        <img [style.width]="'100%'" [src]="this._UiHelper.sliderWebData[0]?.FileName" alt="" [style.object-fit]="'contain'" style="object-position: left" />
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'terminalPeru'">
      <div class="slider-desktop">
        <img [style.width]="'100%'" src="https://cdnsport.s3.eu-central-1.amazonaws.com/cms/main_banner.png" alt="" [style.object-fit]="'contain'" style="object-position: left" />
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div *ngIf="this._UiHelper.sliderWebData && this._UiHelper.sliderWebData.length > 0" class="slider-desktop" (click)="goToLink(this._UiHelper.sliderWebData[0]?.Link)">
        <img [style.width]="'100%'" [src]="this._UiHelper.sliderWebData[0]?.FileName" alt="" [style.object-fit]="'contain'" style="object-position: left" />
      </div>
    </ng-container>
  </ng-container>
  <div class="slider-container">
    <slider [data]="this._DataHelper.homeSliderData" [slideShow]="true" [slideShowTime]="5" [heightMultiper]="1" [objectFit]="'cover'" [isLive]="false"></slider>
  </div>

  <div class="container">
    <div class="header whiteText">
      <div class="header-text">
        {{ 'Sports' | t }}
      </div>
    </div>
    <div class="content">
      <div class="sports-container">
        <div class="odd-header">
          <div class="time-filter">
            <mat-button-toggle-group name="timefilter" class="time-filter-group" value="0" (change)="timeFilterChanged($event.value)">
              <mat-button-toggle value="0">{{ 'All' | t }}</mat-button-toggle>
              <mat-button-toggle value="1">{{ 'Today' | t }}</mat-button-toggle>
              <mat-button-toggle value="7">{{ 'b3000_timeFilter_week' | t }}</mat-button-toggle>
              <mat-button-toggle value="15">{{ 'bet3000_Two_Weeks' | t }}</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <div class="odd-combo-row">
            <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(0)" class="combo-box">
              <select [(ngModel)]="combo1SelectedOdd" (change)="oddComboChange(combo1SelectedOdd, 0)">
                <option *ngFor="let odd of oddComboList" [ngValue]="odd">
                  {{ odd.OddNameLong | t }}
                </option>
              </select>
            </div>

            <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(1)" class="combo-box">
              <select [(ngModel)]="combo2SelectedOdd" (change)="oddComboChange(combo2SelectedOdd, 1)">
                <option *ngFor="let odd of oddComboList" [ngValue]="odd">
                  {{ odd.OddNameLong | t }}
                </option>
              </select>
            </div>

            <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(2)" class="combo-box">
              <select [(ngModel)]="combo3SelectedOdd" (change)="oddComboChange(combo3SelectedOdd, 2)">
                <option *ngFor="let odd of oddComboList" [ngValue]="odd">
                  {{ odd.OddNameLong | t }}
                </option>
              </select>
            </div>

            <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(3)" class="combo-box">
              <select [(ngModel)]="combo4SelectedOdd" (change)="oddComboChange(combo4SelectedOdd, 3)">
                <option *ngFor="let odd of oddComboList" [ngValue]="odd">
                  {{ odd.OddNameLong | t }}
                </option>
              </select>
            </div>
          </div>
          <!-- Odd Titles => Odd Buttonların içine taşındı , bu yüzden kapatıldı. 28-02-2022 -->
          <!--          <div class="odd-combo-row title-row">-->
          <!--            <div class="combo-box-title">-->
          <!--              <div class="odd-title" *ngFor="let odd of combo1SelectedOdd.OddTitles">-->
          <!--                {{odd}}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="combo-box-title">-->
          <!--              <div class="odd-title" *ngFor="let odd of combo2SelectedOdd.OddTitles">-->
          <!--                {{odd }}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="combo-box-title">-->
          <!--              <div class="odd-title" *ngFor="let odd of combo3SelectedOdd.OddTitles">-->
          <!--                {{odd }}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="combo-box-title">-->
          <!--              <div class="odd-title" *ngFor="let odd of combo4SelectedOdd.OddTitles">-->
          <!--                {{odd }}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!-- Odd Titles => Odd Buttonların içine taşındı , bu yüzden kapatıldı. 28-02-2022 -->
        </div>

        <div class="odd-header mobile">
          <div class="odd-box-row">
            <div class="odd-box" *ngFor="let odd of oddComboList" [ngClass]="{ active: combo1SelectedOdd.OddId == odd.OddId }" (click)="oddBoxClick(odd, 0)">
              {{ odd.OddName | t }}
            </div>
          </div>

          <div class="odd-combo-row title-row">
            <div class="combo-box-title">
              <div class="odd-title" *ngFor="let odd of combo1SelectedOdd.OddTitles">
                {{ odd }}
              </div>
            </div>
            <div class="combo-box-title">
              <div class="odd-title" *ngFor="let odd of combo2SelectedOdd.OddTitles">
                {{ odd }}
              </div>
            </div>
            <div class="combo-box-title">
              <div class="odd-title" *ngFor="let odd of combo3SelectedOdd.OddTitles">
                {{ odd }}
              </div>
              <image-loader-utils
                *ngIf="this._DataHelper.LeagueData != undefined && this._DataHelper.LeagueData.length > 0"
                url="star"
                [extraClasses]="'star-icon ' + (tournamentFavourited ? 'favorited' : '')"></image-loader-utils>
            </div>
          </div>
        </div>

        <div class="sports-breadcrumb">
          <div class="left" [routerLink]="['/allsports']">
            <image-loader-utils url="up-arrow" extraClasses="arrow-icon left"></image-loader-utils>
          </div>
          <div class="mid">
            <ng-container *ngIf="sportName !== ''">
              <span (click)="goBack()">
                {{ sportName }}
              </span>

              <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils>

              <span (click)="goBack()">
                <!-- [routerLink]="['/allsports/'+ sportId]" -->
                {{ countryName }}
              </span>

              <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils>

              <span [routerLink]="['/allsports/' + sportId]">
                {{ leagueName }}
              </span>
            </ng-container>
            <ng-container *ngIf="sportName === ''">
              <div [routerLink]="['/allsports/']" class="sport-row">Sports</div>
              <!-- <span [routerLink]="['/allsports/'+ sportId]">
                Sports
              </span> -->
            </ng-container>
          </div>
          <div class="right" (click)="add2TournamentFavs()">
            <image-loader-utils url="star" extraClasses="star-icon"></image-loader-utils>
          </div>
        </div>

        <ng-container *ngIf="_UiHelper.sportSearchInputActive">
          <inputb3 [extraClass]="'amountInput'" fPlaceholder="{{ 'Search' | t }}" fInputType="text" [(ngModel)]="searchInput" (ngModelChange)="searchInputChange($event)"></inputb3>
        </ng-container>

        <prematch-component
          (favChanged)="getFavs()"
          [oddMarketingValue]="oddMarketingB3000Value"
          [preMatchobservable]="this.preMatchobservable"
          [_selectedOdds]="this._selectedOdds"
          [oddTiles]="combo1SelectedOdd.OddTitles"></prematch-component>
      </div>
    </div>

    <outrights-component *ngIf="this.tournamentSelectionB3000.isTournamentSelection" [setTournament]="this.tournamentSelectionB3000.tournamentBetradarId"></outrights-component>
    <!--{{this.tournamentSelection.tournamentId}}-->
    <div *ngIf="this.tournamentSelectionB3000.data?.length > 0" class="statistics-container">
      <div class="tournament-standings">
        <div class="standings-wrapper">
          <div class="m-standings-selection d-flex mx-auto">
            <div
              (click)="tournamentStatsPage1('total')"
              [ngClass]="{ active: tournamentSelectionB3000.page === 1 && tournamentSelectionB3000.page1InsideSelection === 'total' }"
              class="m-selection">
              {{ 'bet3000_League_table' | t }}
            </div>
            <div
              (click)="tournamentStatsPage1('home')"
              [ngClass]="{ active: tournamentSelectionB3000.page === 1 && tournamentSelectionB3000.page1InsideSelection === 'home' }"
              class="m-selection">
              {{ 'Home' | t }}
            </div>
            <div
              (click)="tournamentStatsPage1('away')"
              [ngClass]="{ active: tournamentSelectionB3000.page === 1 && tournamentSelectionB3000.page1InsideSelection === 'away' }"
              class="m-selection">
              {{ 'Away' | t }}
            </div>
            <div class="m-selection" (click)="tournamentSelectionState(2)" [ngClass]="{ active: tournamentSelectionB3000.page === 2 }">Form table</div>
          </div>
          <div class="table-header d-flex align-items-center justify-content-end px-2 px-md-3">
            <h3 class="mr-auto">{{ 'b3000_statistics' | t }}</h3>
            <div class="standings-selection d-flex ml-auto">
              <div class="selection mx-1 {{ tournamentSelectionB3000.page === 1 ? 'active' : '' }}" (click)="tournamentSelectionState(1)">
                {{ 'bet3000_League_table' | t }}
              </div>
              <div class="selection mx-1 {{ tournamentSelectionB3000.page === 2 ? 'active' : '' }}" (click)="tournamentSelectionState(2)">
                {{ 'bet3000_Form_table' | t }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div *ngIf="tournamentSelectionB3000.page === 1" class="table-wrap">
            <div class="table-head d-flex">
              <div class="league-name my-auto"></div>
              <div class="league-legend-row">
                <div class="league-legend-left">{{ tournamentSelectionB3000.data[0]?.TournamentName }}</div>
                <div class="league-legend d-flex">
                  <div class="label mt-auto">{{ 'bet3000_Pl' | t }}</div>
                  <div class="label mt-auto">{{ 'bet3000_W' | t }}</div>
                  <div class="label mt-auto">{{ 'bet3000_D' | t }}</div>
                  <div class="label mt-auto">{{ 'bet3000_L' | t }}</div>
                  <div class="label mt-auto d-none d-lg-block">{{ 'bet3000_PTS' | t }}</div>
                  <div class="label mt-auto">{{ 'bet3000_Goals' | t }}</div>
                  <div class="label position d-none d-xl-block mobile-display-none">
                    <div class="d-flex flex-column">
                      <div class="mx-auto">{{ 'Home' | t }}</div>
                      <div class="d-flex mt-auto">
                        <div style="flex: 1; text-align: center">{{ 'bet3000_W' | t }}</div>
                        <div style="flex: 1; text-align: center">{{ 'bet3000_D' | t }}</div>
                        <div style="flex: 1; text-align: center">{{ 'bet3000_L' | t }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="label position mt-auto d-none d-xl-block mobile-display-none">
                    <div class="d-flex flex-column">
                      <div class="mx-auto">{{ 'Away' | t }}</div>
                      <div class="d-flex mt-auto">
                        <div style="flex: 1; text-align: center">{{ 'bet3000_W' | t }}</div>
                        <div style="flex: 1; text-align: center">{{ 'bet3000_D' | t }}</div>
                        <div style="flex: 1; text-align: center">{{ 'bet3000_L' | t }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="table-body d-flex" *ngFor="let tItem of this.tournamentSelectionB3000.data; let i = index">
                <div class="club-name d-flex my-auto">
                  <div class="item name d-none d-lg-block">
                    <div class="d-flex h-100">
                      <div class="my-auto">{{ i + 1 + '. ' + tItem.CompetitorName }}</div>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="this.tournamentSelection.page1InsideSelection === 'total'">
                  <div class="club-info d-flex my-auto">
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Played }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Win }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Draw }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Loss }}</div>
                      </div>
                    </div>
                    <div class="item bold d-none d-lg-block">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Points }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Tore }}</div>
                      </div>
                    </div>
                    <div class="item bordered d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HWin }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HDraw }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HLos }}</div>
                      </div>
                    </div>
                    <div class="item bordered d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.AWin }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ADraw }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ALos }}</div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="this.tournamentSelection.page1InsideSelection === 'home'">
                  <div class="club-info d-flex my-auto">
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HPlayed }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HWin }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HDraw }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HLos }}</div>
                      </div>
                    </div>
                    <div class="item bold d-none d-lg-block">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HPoint }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">-</div>
                      </div>
                    </div>
                    <div class="item bordered d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.AWin }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ADraw }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ALos }}</div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="this.tournamentSelection.page1InsideSelection === 'away'">
                  <div class="club-info d-flex my-auto">
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.APlayed }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.AWin }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ADraw }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ALos }}</div>
                      </div>
                    </div>
                    <div class="item bold d-none d-lg-block">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.APoint }}</div>
                      </div>
                    </div>

                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">-</div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="disclaimer">{{ 'bet3000_Sports_Text_1' | t }}</div>
          </div>

          <div *ngIf="tournamentSelectionB3000.page === 2" class="table-wrap">
            <div class="table-head formTable d-flex">
              <div class="leauge-form-row">
                <div class="league-form">
                  <div class="league-legend-left">
                    <div class="season-name">
                      {{ tournamentSelectionB3000.data[0]?.TournamentName }}
                    </div>
                    <div class="underline-arrow">letzte 6 Sp.</div>
                  </div>
                </div>
                <div class="league-legend d-flex">
                  <div></div>
                  <div class="label mt-auto">{{ 'bet3000_W' | t }}</div>
                  <div class="label mt-auto">{{ 'bet3000_D' | t }}</div>
                  <div class="label mt-auto">{{ 'bet3000_L' | t }}</div>
                  <div class="label mt-auto">{{ 'bet3000_Goals' | t }}</div>
                  <div class="label mt-auto">{{ 'bet3000_PTS' | t }}</div>
                </div>
              </div>
            </div>
            <div class="table-body formTableB d-flex" *ngFor="let tItem of this.tournamentSelectionB3000.data; let k = index">
              <div class="club-name d-flex my-auto">
                <div class="item name d-none d-lg-block">
                  <div class="d-flex h-100">
                    <div class="my-auto">{{ k + 1 + '. ' + tItem.CompetitorName }}</div>
                  </div>
                </div>
              </div>
              <div class="club-form d-flex my-auto">
                <div class="item">
                  <div class="d-flex h-100" style="width: 100%">
                    <div class="my-autto mx-auto" style="flex: 1; justify-content: space-around; display: flex">
                      <ng-container *ngFor="let item of getFormTableDataTranslate(tItem.Form)">
                        <div [ngClass]="{ 'statu-dot-lost': item == '0', 'statu-dot-won': item == '3', 'statu-dot-d': item == '1' }"></div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div class="club-info d-flex my-auto">
                <div class="item">
                  <div class="d-flex h-100">
                    <div class="my-auto mx-auto">{{ tItem.FormWin }}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="d-flex h-100">
                    <div class="my-auto mx-auto">{{ tItem.FormDraw }}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="d-flex h-100">
                    <div class="my-auto mx-auto">{{ tItem.FormLost }}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="d-flex h-100" style="flex-shrink: 0">
                    <div class="my-auto mx-auto">-</div>
                  </div>
                </div>
                <div class="item bold">
                  <div class="d-flex h-100">
                    <div class="my-auto mx-auto">{{ tItem.FormPoints }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="disclaimer">{{ 'bet3000_Sports_Text_1' | t }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
